import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestObserverService {
  // true, means a request is pending evaluation
  // false, means a request has failed evaluation
  private requestStatusSubject = new BehaviorSubject<boolean>(false);
  // true, means a blocking request is occurring
  // false, means a blocking request is not occuring
  private acceptingRequestsSubject = new BehaviorSubject<boolean>(true);
  requestStatus$: Observable<boolean> =
    this.requestStatusSubject.asObservable();
  acceptingRequests$: Observable<boolean> =
    this.acceptingRequestsSubject.asObservable();

  beginRequest() {
    this.requestStatusSubject.next(true);
    this.closeRequests();
  }

  reportError() {
    this.requestStatusSubject.next(false);
    this.openRequests();
  }

  endRequest() {
    this.requestStatusSubject.next(false);
    this.openRequests();
  }

  private openRequests() {
    this.acceptingRequestsSubject.next(true);
  }

  private closeRequests() {
    this.acceptingRequestsSubject.next(false);
  }

  getRequestStatus(): boolean {
    let requestEval = false;
    this.requestStatus$.subscribe((requestStatus) => {
      requestEval = requestStatus;
    });
    return requestEval;
  }

  isAcceptingRequest(): boolean {
    let isAccepting = false;
    this.acceptingRequests$.subscribe((acceptingRequests) => {
      isAccepting = acceptingRequests;
    });
    return isAccepting;
  }
}
